if (!customElements.get("x-tooltip")) {
  class ToolTip extends HTMLElement {
    constructor() {
      super();

      this.trigger = this.querySelector(".tooltip-trigger");
      this.body = this.querySelector(".tooltip-body");
    }

    handleClick = (e) => {
      if (this.contains(e.target) && this.body.classList.contains("hidden")) {
        this.showToolTip();
      } else if (!this.contains(e.target)) {
        this.hideToolTip();
      }
    };

    showToolTip = () => {
      this.body.classList.remove("hidden");
    };

    hideToolTip = () => {
      this.body.classList.add("hidden");
    };

    connectedCallback() {
      document.addEventListener("click", this.handleClick.bind(this));
    }
    disconnectedCallback() {
      document.removeEventListener("click", this.handleClick.bind(this));
    }
  }

  customElements.define("x-tooltip", ToolTip);
}
